import React, { useMemo } from 'react';
import { useSnackbar } from "@durlabh/dframework-ui";
import { releaseManagementConfig } from "./ReleaseManagementModel";
import CommonUiModel from "../common/commonUiModel";

const releaseManagement = new CommonUiModel(releaseManagementConfig);

const statusMessageMap = {
    118: 'Production',
    117: 'Lock For Approval'
};

const ReleaseManagementForm = ({ models, documentGroupId }) => {
    const { showMessage } = useSnackbar();

    const memoizedModels = useMemo(() => models, [models]);

    const memoizedRelationFilters = useMemo(() => ({
        "Document": [{
            field: "DocumentGroupId",
            operator: "is",
            type: "Number",
            value: documentGroupId
        }]
    }), [documentGroupId]);

    const beforeFormSubmit = ({ formik }) => {
        const { RevisionStatusId: revisionStatusId } = formik.values;
        if (revisionStatusId in statusMessageMap) {
            showMessage('Note', `Processing your ${statusMessageMap[revisionStatusId]} request, may take upto 10 seconds`, 'info');
        }
    };

    return (
        <releaseManagement.Form
            beforeSubmit={beforeFormSubmit}
            models={memoizedModels}
            relationFilters={memoizedRelationFilters}
        />
    );
};

export default React.memo(ReleaseManagementForm);
